import { ROLE_LABEL, PERMISSIONS, BRAND } from '@app/shared/core';
import { useApp, type ThemeMode } from '../state';
import { Icon, PageHead, Seg } from '../ui';
import { TopBar } from './TopBar';

/** Вкладка «Ещё»: профиль, оформление и разделы администратора. */
export function More() {
  const { me, can, open, themeMode, setThemeMode } = useApp();
  const e = me.employee!;
  const admin = [
    can('staff.manage') && { key: 'staff', icon: 'users', title: 'Сотрудники', sub: 'Список, роли, участки, попытки входа', count: me.loginAttempts, go: () => open({ name: 'staff' }) },
    can('panel.manage') && { key: 'eq', icon: 'factory', title: 'Оборудование', sub: 'Участки и панели, проверка связи', count: 0, go: () => open({ name: 'equipment' }) },
    can('panel.log') && { key: 'log', icon: 'log', title: 'Журнал подключений', sub: 'Кто сейчас на панелях, что нажимал', count: 0, go: () => open({ name: 'sessions' }) },
  ].filter(Boolean) as { key: string; icon: string; title: string; sub: string; count: number; go: () => void }[];

  return (
    <div className="stack">
      <TopBar />
      <PageHead title="Ещё" />

      <section className="card stack" style={{ gap: 8 }}>
        <div className="h2">{e.fullName}</div>
        <div className="row wrap" style={{ gap: 8 }}>
          {e.role && <span className="badge solid">{ROLE_LABEL[e.role]}</span>}
          {e.position && <span className="small muted">{e.position}</span>}
        </div>
        <details>
          <summary className="small muted" style={{ cursor: 'pointer' }}>
            Что мне доступно
          </summary>
          <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
            {me.permissions.map((p) => (
              <li key={p} className="small">
                {PERMISSIONS[p]}
              </li>
            ))}
          </ul>
        </details>
      </section>

      {admin.length > 0 && (
        <>
          <h2 className="section-title">Управление</h2>
          <div className="list">
            {admin.map((a) => (
              <button key={a.key} type="button" className="item" onClick={a.go}>
                <span className="mark">
                  <Icon name={a.icon} />
                </span>
                <span className="grow">
                  <span className="title" style={{ display: 'block' }}>
                    {a.title}
                  </span>
                  <span className="sub">{a.sub}</span>
                </span>
                {a.count > 0 && <span className="count">{a.count}</span>}
                <span className="chev">
                  <Icon name="right" size={18} />
                </span>
              </button>
            ))}
          </div>
        </>
      )}

      <h2 className="section-title">Оформление</h2>
      <Seg<ThemeMode>
        label="Тема"
        value={themeMode}
        onChange={setThemeMode}
        options={[
          { value: 'auto', label: 'Авто' },
          { value: 'light', label: 'Светлая' },
          { value: 'dark', label: 'Тёмная' },
        ]}
      />

      <p className="small muted" style={{ textAlign: 'center', marginTop: 16 }}>
        {BRAND.name} · этап 1
      </p>
    </div>
  );
}
